{
  "zh-CN": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      }
    }
  }
}
